import React from "react";
import { useNavigate } from "react-router-dom";
import "./CTA.css";

const CTA = () => {
  const navigate = useNavigate();

  const handleGetQuote = (category, subcategory) => {
    const whatsappNumber = "923170725045";
    const message = encodeURIComponent(
      `Hi! I'm interested in getting a quote for ${category} - ${subcategory}. Can you please provide more information?`,
    );
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, "_blank");
  };

  const handleContactClick = () => {
    navigate("/contact");
  };

  return (
    <div className="services-cta">
      <div className="cta-content">
        <h2 className="cta-title">Ready to Start Your Project?</h2>
        <p className="cta-description">
          Let's discuss how we can help bring your ideas to life with our
          comprehensive service solutions
        </p>
        <div className="cta-buttons">
          <button
            className="cta-button primary"
            onClick={() => handleGetQuote("General", "Project Consultation")}
          >
            Get Free Consultation
          </button>
          <button className="cta-button secondary" onClick={handleContactClick}>
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default CTA;
